/**
 * Swing fill after reload: checkbox selection is empty even when the same
 * row identity is still in the store.
 */
export function checkboxSelectionAfterItemsReload<T>(
  _selection?: readonly T[] | null,
  _nextItems?: readonly T[],
): T[] {
  return []
}
